import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "../mock";

const FloatingButtons = () => {
  const wa = CONTACT.whatsappNumber.replace(/\D/g, "");
  return (
    <div className="float-btns">
      <a href={`tel:${CONTACT.callNumber}`} className="float-btn call" title="Call Now" aria-label="Call">
        <Phone size={20} />
      </a>
      <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="float-btn wa" title="WhatsApp" aria-label="WhatsApp">
        <MessageCircle size={20} />
      </a>
    </div>
  );
};

export default FloatingButtons;
